<template>
  <modal name="DocumentListFasilitas" :draggable="false" :scrollable="true" :height="'auto'">
    <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
      <div class="modal-dialog  modal-xl">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> Daftar Dokumen </h5>
            <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <vue-good-table title="list-dokumen-fasilitas" :rows="rowsDokumenFasilitas" :columns="columnFasilitas"
              @on-selected-rows-change="selectionChanged" :select-options="{ enabled: true, selectOnCheckboxOnly: true,disableSelectInfo:true }"
              :line-numbers="true" 
              >
              <div slot="emptystate">
                Empty Row
              </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'jenisFasilitas'">
                  {{ props.row.kodeDokumen + " - " + props.row.namaDokumen }}
                </span>
                <span v-else-if="props.column.field == 'fasilitas'">
                  {{ props.row.kodeFasilitas ? props.row.kodeFasilitas + " - " + props.row.namaFasilitas : "" }}
                </span>
                <span v-else-if="props.column.field == 'izin'">
                  <input type="text" class="form-control" v-model="props.row[props.column.field]"
                    @change="changeCell(props.row[props.column.field], props.column.field, props.row.originalIndex)">
                </span>

                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">Batal</button>
            <button type="button" class="btn btn-primary" @click.prevent="submitData()">Simpan</button>
          </div>

        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "DocumentListFasilitas",
  props: {
    propsData: { type: [Object, Array] }
  },
  data() {
    return {
      rowsDokumenFasilitas: [],
      columnFasilitas: [
        {
          label: "Jenis",
          field: 'jenisFasilitas',
          type: 'text',
          thClass: 'text-center',
        },
        {
          label: "Nomor",
          field: 'nomorDokumen',
          type: 'text',
          thClass: 'text-center',
        },
        {
          label: "Tanggal",
          field: 'tanggalDokumen',
          type: 'text',
          thClass: 'text-center',
        },
        {
          label: "Fasilitas",
          field: 'fasilitas',
          type: 'text',
          thClass: 'text-center',
        },
        {
          label: "Izin",
          field: 'izin',
          type: 'text',
          width: "200px",
          thClass: 'text-center',
        },
        {
          label: "File",
          field: 'file',
          type: 'text',
          thClass: 'text-center',
        },
      ],
      selectedRow: [],
    }
  },
  methods: {
    removeModals() {
      this.selectedRow = [];
      this.$modal.hide('DocumentListFasilitas');
    },
    changeCell(changedData, column, row) {
      this.rowsDokumenFasilitas[row][column] = changedData
    },
    selectionChanged(ev) {
      this.selectedRow = [];
      this.selectedRow = ev.selectedRows;
    },
    submitData(){
      this.$emit("closeModal",this.selectedRow);
      this.removeModals();
    }
  },
  created() { },
  watch: {
    propsData: function (newVal) {
      this.rowsDokumenFasilitas = newVal;
      // this.reAssignValue();

    },
  }
}
</script>

<style></style>